export interface TimeLog {
  id?: string;
  user_id?: string;
  log_date: string;
  check_in?: string;
  check_out?: string;
  hours?: number;
  status?: string;
}

export interface ActiveBreak {
  id: string;
  break_type: string;
  started_at: string;
}

export interface TodayResponse {
  log: TimeLog | null;
  activeBreak: ActiveBreak | null;
}

export interface TeamMember {
  id: string;
  display_name: string;
  department?: string;
  check_in?: string;
  check_out?: string;
  hours?: number;
}

/** Shared status classification for a team roster row — used by both the
 *  Team Attendance table and the Attendance page's summary stat row so the
 *  two stay in sync by construction. */
export function memberState(m: TeamMember): 'present' | 'checked_out' | 'absent' {
  if (m.check_out) return 'checked_out';
  if (m.check_in) return 'present';
  return 'absent';
}

export type BreakType = 'lunch' | 'tea' | 'bio' | 'meeting';

export const BREAK_OPTIONS: { value: BreakType; label: string }[] = [
  { value: 'lunch', label: 'Lunch' },
  { value: 'tea', label: 'Tea' },
  { value: 'bio', label: 'Restroom' },
  { value: 'meeting', label: 'Meeting' },
];
